/**
 * riskactions.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../actiontypes';
import {API_RESOURCES, createApiReadAction} from '../../util/api';

export const RiskTypesValidExpands = {
	Risks: 'risks',
	RiskFactorRelations: 'risks.riskfactors',
	Assertions: {
		Assertions: 'risks.assertions',
		Accounts: 'risks.assertions.account',
		Scots: {
			Scots: 'risks.assertions.scots',
			Wcgws: 'risks.assertions.scots.wcgws'
		}
	}
};

// Deprecated. Use getRiskTypes function instead.
export const getRiskTypes_old = (url, resource) => {
	return {
		type: types.GET_RISK_TYPES,
		meta: {
			api: {
				url,
				method: 'GET',
				data: {resource}
			}
		}
	};
};

export const getRiskTypes = (engagementId, queryParameters, actionArgs, trackWithArea) => {
	return createApiReadAction(
		types.GET_RISK_TYPES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKTYPES]: undefined
		},
		queryParameters,
		{
			...actionArgs,
			resolve: true
		},
		undefined,
		trackWithArea
	);
};
